var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.77 49.23"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.21 0H6.56A6.56 6.56 0 000 6.56v36.11a6.56 6.56 0 006.56 6.56h15.65a6.56 6.56 0 006.56-6.56V6.56A6.56 6.56 0 0022.21 0m-7.83 1.7a1.56 1.56 0 11-1.56 1.56 1.56 1.56 0 011.56-1.56m0 46.62A2.59 2.59 0 1117 45.73a2.58 2.58 0 01-2.59 2.59m10.34-6.11H4V6.91h20.72z",
    fill: "#999",
    "data-name": "Layer 1"
  }))));
}
export default SvgDevice;